import { useState, useEffect, useRef } from 'react'
import { NoRecords, PageLoader } from '../../lib/loader'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from 'moment';
import { useUserHistory, useSupdateBlockstatus, useUpdateUserAccess, useLoginAsUser } from './UserDetailapi';
import { Search, Eye, Copy, Check, UserRoundPen, UserCog } from 'lucide-react';
import { useDebounce } from '../../hooks/debounce';
import { useParams, useNavigate } from 'react-router-dom';
import { queryClient } from "../../config";
import { copyToClipboard } from '../../lib/copytoClipboard';
import { useModalContext } from '../../contexts/ModalContext';
import { useToast } from '../../hooks/usetoast';
import { useCheckAdminAccess } from '../WhiteIp/api/whiteipapi';
import { logout } from '../../hooks/logout';
import PermissionDenied from '../common/permissionDenied';
import { Modal, ModalBody } from 'reactstrap';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import user from '../../assets/images/icons/user.svg';
import { Controller, useForm } from 'react-hook-form';
import { useBreadcrumbPagination } from '../../hooks/useBreadcrumbPagination';
import BreadcrumbPagination from '../../utils/BreadcrumbPagination';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';


const schema = yup.object().shape({
    status: yup.boolean(),
});

const allOptions = [
    { module: "Internal Transfer" },
    { module: "Deposit" },
    { module: "Withdraw" },
    { module: "Virtual_Cards" },
    { module: "Card_Topup" },
];


function BlockedUserHistory() {

    const { handleSubmit, control, setValue } = useForm({
        mode: 'onChange',
        resolver: yupResolver(schema),
    });
    const [loading, setLoading] = useState(false);
    const [tempPage, setTempPage] = useState(0);
    const [tempRows, setTempRows] = useState(25);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);

    const [search, setSearch] = useState("");
    const searchText = useDebounce(search);
    const { id } = useParams();
    const navigate = useNavigate()
    const { theme } = useModalContext()
    const toast = useToast();
    const [userEmail, setUserEmail] = useState(false);
    const [open, setOpen] = useState(false);
    const toggle = () => setOpen(!open);
    const inputRef = useRef(null);


    const userLoginMutation = useLoginAsUser();

    const { data: getUserHistory, isLoading } = useUserHistory({
        id,
        page: searchText ? 0 : tempPage,
        size: tempRows,
        type: 'blocked',
        searchText,
        sortField: "createdAt",
        sortOrder: "desc"
    })

    const totalRecords = getUserHistory?.data?.totalRecords || 0;

    const {
        page,
        rowsPerPage,
        totalPages,
        handleChangePage,
        handleChangeRowsPerPage
    } = useBreadcrumbPagination(totalRecords, tempRows);

    useEffect(() => {
        setTempPage(page);
    }, [page]);

    useEffect(() => {
        setTempRows(rowsPerPage);
    }, [rowsPerPage]);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
            const length = inputRef.current.value.length;
            inputRef.current.setSelectionRange(length, length);
        }
    });

    useEffect(() => {
        setTempPage(0);
        if (handleChangePage) {
            handleChangePage(null, 0);
        }
    }, [searchText]);


    const handleUser = (row) => {
        navigate(`/SingleUserHistory/${row._id}`);
        localStorage.setItem("_id", row._id)
    };

    const updateBlockstatus = useSupdateBlockstatus()


    const userStatus = async (item, updateField) => {
        let obj = {
            userId: item._id,
            status: updateField,
        };
        const updateStatus = await updateBlockstatus.mutateAsync({ ...obj });
        if (updateStatus?.message === "Status blocked successfully") {
            queryClient?.refetchQueries(["user-history", item._id]);
        }
    };

    const copyUserEmailAddress = async data => {
        setUserEmail(data._id)
        await copyToClipboard(data?.email)
        toast.success("Email Address copied")
        setTimeout(() => {
            setUserEmail()
        }, 800)
    }


    const checkAdminMutation = useCheckAdminAccess();
    const [access, setAccess] = useState(true);

    useEffect(() => {
        checkAdminAccess();
    }, []);



    const checkAdminAccess = async () => {
        try {
            const obj = { page: "User Management" };
            const checkAdminRes = await checkAdminMutation.mutateAsync(obj);
            if (!checkAdminRes?.data?.status) {
                setAccess(false);
                logout();
            } else {
                setAccess(true);
            }
        } catch (error) {
            setAccess(false);
        }
    };

    const [singleview, setSingleview] = useState('');
    const [selectedOptions, setSelectedOptions] = useState([]);
    const updatePermission = useUpdateUserAccess();

    const Edit = async (item) => {
        setSingleview(item);
        setSelectedOptions(item?.permission || []);
        setValue('permission', item?.permission || []);
        toggle();
    };

    const handleOptionChange = (option, checked) => {
        setSelectedOptions((prevSelectedOptions) => {
            let updatedSelectedOptions = [...prevSelectedOptions];
            const existingOptionIndex = updatedSelectedOptions.findIndex(
                (item) => item.title === option.module
            );

            if (existingOptionIndex !== -1) {
                if (!checked) {
                    updatedSelectedOptions.splice(existingOptionIndex, 1);
                }
            } else if (checked) {
                updatedSelectedOptions.push({
                    title: option.module,
                    status: checked,
                });
            }

            setValue('permission', updatedSelectedOptions);
            if (updatedSelectedOptions.length > 0) {
                setValue('permission', updatedSelectedOptions, { shouldValidate: true });
            }
            return updatedSelectedOptions;
        });
    };

    const arraysAreEqual = (arr1, arr2) => {
        if (!arr1 || !arr2 || arr1.length !== arr2.length) return false;
        return arr1.every((item, index) =>
            item.title === arr2[index].title &&
            item.icon === arr2[index].icon &&
            item.link === arr2[index].link &&
            item.status === arr2[index].status
        );
    };

    const onSubmit = async (data) => {

        setLoading(true)
        const permissionsChanged = !arraysAreEqual(singleview?.permission, selectedOptions);

        if (permissionsChanged) {
            const obj = {
                _id: singleview?._id,
                permission: selectedOptions,
            };
            const res = await updatePermission.mutateAsync(obj);
            if (res.status) {
                toast.success("Status updated");
                queryClient.refetchQueries('user-history');
                setLoading(false)
                setOpen(false);
            } else {
                toast.error(res.message);
                setLoading(false)
                setOpen(false);
            }
        } else {
            toast.error("No changes done");
            setLoading(false)
            setOpen(false)
        }
    };


    const openLoginDialog = (user) => {
        setSelectedUser(user);
        setDialogOpen(true);
    };

    const confirmLoginAsUser = async () => {
        setLoading(true)
        try {
            const resp = await userLoginMutation.mutateAsync({
                id: selectedUser?._id
            })
            if (!resp?.status) {
                toast.error(resp?.data?.message);
                setLoading(false)

            } else {
                toast.success(resp?.data?.message)
                window.open(`https://roupay.io/adminLogin/${resp?.data?.token}`, '_blank');
            }

        } catch (error) {
            console.error("Error login as user:", error);
        } finally {
            setDialogOpen(false);
            setLoading(false)
        }
    }



    const renderUserHistoryTable = () => (
        getUserHistory?.data?.usersHistory?.length > 0 ? (
            <>
                <div style={{ minHeight: "60vh" }}>
                    <div className='table-responsive'>
                        <Table sx={{ minWidth: 650 }} aria-label="user history table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">S.NO</TableCell>
                                    <TableCell align="center">Login Type</TableCell>
                                    <TableCell align="center">User Name</TableCell>
                                    <TableCell align="center">Email</TableCell>
                                    <TableCell align="center">Email Verified</TableCell>
                                    <TableCell align="center">User Access</TableCell>
                                    <TableCell >Blocked</TableCell>
                                    <TableCell align="center">Date and Time </TableCell>
                                    <TableCell align="center">Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getUserHistory?.data?.usersHistory?.map((row, i) => (
                                    <TableRow key={row._id || i}>
                                        <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                                        <TableCell align="center">{row?.type?.toUpperCase() || "-"}</TableCell>
                                        <TableCell align="center">{row?.userName || "-"}</TableCell>
                                        <TableCell align="center">
                                            {row?.email || "-"}
                                            {row?.email && userEmail !== row._id && (
                                                <Copy
                                                    onClick={() => copyUserEmailAddress(row)}
                                                    size={20}
                                                    className='ml-5'
                                                    style={{
                                                        cursor: "pointer",
                                                        marginLeft: "5px",
                                                        color: theme ? "white" : "black"
                                                    }}
                                                />
                                            )}
                                            {row?.email && userEmail === row._id && (
                                                <Check
                                                    size={20}
                                                    style={{
                                                        marginLeft: "5px",
                                                        color: theme ? "white" : "black"
                                                    }}
                                                />
                                            )}
                                        </TableCell>

                                        <TableCell align="center">{row?.isEmailVerified ? "Yes" : "No"}</TableCell>
                                        <TableCell align="center"><UserRoundPen className="mx-3" size={20} onClick={() => Edit(row)} type='button' /></TableCell>
                                        <TableCell align="center">
                                            <div className="form-check form-switch">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    role="switch"
                                                    id={`flexSwitchCheckDefault-${row._id}`}
                                                    checked={row?.isBlocked}
                                                    onChange={() => userStatus(row, !row?.isBlocked)}
                                                />
                                            </div>
                                        </TableCell>

                                        <TableCell align="center">
                                            {moment(row?.createdAt).format("DD-MM-YYYY | hh:mm A")}
                                        </TableCell>

                                        <TableCell align="center">
                                            <Eye className="mx-3" size={20} type='button' onClick={() => handleUser(row)}
                                            />
                                            <UserCog size={20} type='button' onClick={() => openLoginDialog(row)} />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <BreadcrumbPagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                />

                <Modal isOpen={open} toggle={toggle} centered>
                    <div className="modal-header">
                        <h1 className="modal-title fs-5"> Update Accessibility</h1>
                        <button type="button" className="btn-close" onClick={toggle} aria-label="Close">
                            <img src={require('../../assets/images/icons/close-circle.svg').default} alt="close-circle" />
                        </button>
                    </div>
                    <ModalBody>
                        <form onSubmit={handleSubmit(onSubmit)} noValidate>
                            <div className="col-sm-12 col-md-8 col-lg-8">
                                <div className="input-group mb-3">
                                    <span className="input-group-icon">
                                        <img src={user} className='img-fluid' alt="User" />
                                    </span>
                                    <Controller
                                        name='name'
                                        control={control}
                                        render={({ field }) => (
                                            <input
                                                {...field}
                                                defaultValue={singleview?.userName}
                                                className="form-control"
                                                autoComplete='off'
                                                readOnly
                                            />
                                        )}
                                    />
                                </div>
                                <div className="input-group mb-3">
                                    <span className="input-group-icon">
                                        <img src={user} className='img-fluid' alt="User" />
                                    </span>
                                    <Controller name='email' control={control} render={({ field }) => (
                                        <input
                                            {...field}
                                            className="form-control"
                                            autoComplete='off'
                                            readOnly
                                            defaultValue={singleview?.email}
                                        />
                                    )} />
                                </div>
                                <fieldset style={{ border: 'none', padding: 0, margin: 0 }}>
                                    <legend style={{ fontWeight: "bolder", marginTop: "4px" }}>Modules:</legend>
                                    <div className='mt-3'>
                                        {allOptions.map((option) => {
                                            const isChecked = selectedOptions.some(
                                                (perm) => perm.title === option.module
                                            );

                                            return (
                                                <div key={option.module} className='mb-8 d-flex align-items-center'>
                                                    <input
                                                        type="checkbox"
                                                        id={`module-${option.module}`} // Unique ID for each option
                                                        name={option.module}
                                                        checked={!!isChecked}
                                                        onChange={(e) => handleOptionChange(option, e.target.checked)}
                                                        style={{ marginRight: '10px' }}
                                                    />
                                                    <label htmlFor={`module-${option.module}`} style={{ fontWeight: 'bold' }}>
                                                        {option.module}
                                                    </label>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </fieldset>

                            </div>
                            <div className="d-grid crPgbtn pt-3">
                                <button type="submit" className="btn btn-primary">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </ModalBody>
                </Modal>
                <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
                    <DialogTitle>Confirm Login</DialogTitle>
                    <DialogContent>
                        Are you sure you want to login as user <strong>{selectedUser?.userName}</strong>?
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setDialogOpen(false)} color="secondary">Cancel</Button>
                        <Button onClick={() => confirmLoginAsUser()} color="primary">Confirm</Button>
                    </DialogActions>
                </Dialog>

            </>
        ) : (
            <NoRecords />
        )
    );


    return (
        <>
            {loading && <PageLoader />}
            {isLoading ? (
                <PageLoader />
            ) : access ? (
                <section>
                    <h4>Admin Blocked Users History</h4>
                    <div className="ad_pg_bx bg-white p-3">
                        <div
                            className="d-flex justify-content-between align-items-center mb-2"
                            style={{ flexWrap: 'wrap' }}
                        >
                            <div className="d-flex align-items-center" style={{ gap: '5px' }}>
                                <div className="input-group" style={{ width: '400px' }}>
                                    <span className="input-group-icon">
                                        <Search size={20} color="#aaa9a9" />
                                    </span>
                                    <input
                                        type="text"
                                        ref={inputRef}
                                        onChange={(e) => setSearch(e.target.value)}
                                        className="form-control"
                                        placeholder="Search by name , email"
                                        value={search}
                                        style={{ width: '200px' }}
                                    />
                                </div>
                            </div>
                        </div>
                        {renderUserHistoryTable()}
                    </div>
                </section>
            ) : (
                <PermissionDenied />
            )}


        </>
    )
}

export default BlockedUserHistory